import { PublicKey } from '@solana/web3.js';
import { ReadonlyURLSearchParams } from 'next/navigation';

const AUTHORITY_OVERRIDE = '';
const USER_OVERRIDE = '';

export const getIsInEmulationMode = (
	searchParams: ReadonlyURLSearchParams | null
): boolean => {
	if (!searchParams) return false;

	return !!(
		AUTHORITY_OVERRIDE ||
		USER_OVERRIDE ||
		searchParams.get('authority') ||
		searchParams.get('userAccount')
	);
};

export const getEmulationParams = (
	searchParams: ReadonlyURLSearchParams | null
) => {
	if (!searchParams) return null;

	const authorityParam = AUTHORITY_OVERRIDE || searchParams.get('authority');
	const userAccountParam = USER_OVERRIDE || searchParams.get('userAccount');

	if (authorityParam) {
		return {
			type: 'authority' as const,
			value: authorityParam,
		};
	}

	if (userAccountParam) {
		return {
			type: 'userAccount' as const,
			value: userAccountParam,
		};
	}

	return null;
};

export const isValidPublicKey = (key: string): boolean => {
	try {
		new PublicKey(key);
		return true;
	} catch {
		return false;
	}
};
